<template>
  <div class="wrapper">
    <the-header />
    <the-container class="main">
      <slot />
    </the-container>
    <the-footer class="layout-footer"></the-footer>
  </div>
</template>

<script>
import TheContainer from '@/components/my-page-partials/TheContainer.vue'
import TheHeader from '@/components/TheHeader.vue'
import TheFooter from '@/components/my-page-partials/TheFooter.vue'
import BreadcrumbMixin from '@/mixins/breadcrumb'

export default {
  mixins: [BreadcrumbMixin],
  components: { TheHeader, TheContainer, TheFooter },
  metaInfo() {
    return {
      titleTemplate: `%s | ${this.shopName}`,
    }
  },
}
</script>

<style lang="scss">
@import '@/assets/css/layouts/mypage-layout.scss';
</style>
